import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './TopLimitationContainer';
import { TopLimitationMessage } from './TopLimitationMessage';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

type Props = PropsFromRedux;

export const RawTopLimitation: FC<Props> = ({
  showCutMessage,
  hiddenResults,
  totalHits,
  lastResponse,
  toggleTopResults,
}) => {
  const showHiddenResults = () => {
    const resultsShown = totalHits - hiddenResults;
    doctrineAnalytics('Search ShowHiddenResults', {
      original_query_key: lastResponse,
      nb_results_shown: resultsShown,
      nb_results_hidden: hiddenResults,
    });
    toggleTopResults();
  };

  if (!showCutMessage) return null;

  return (
    <TopLimitationMessage
      hiddenResults={hiddenResults}
      totalHits={totalHits}
      showHiddenResults={showHiddenResults}
    />
  );
};

export const TopLimitation = Connect(RawTopLimitation);
